<template>
  <div class="d-flex justify-content-center">
    <McButton
      variant="secondary"
      text="Lihat Template"
      icon="icon-outline_external-link"
      iconPosition="right"
      size="sm"
      @click="handleClick"
    />
  </div>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    handleClick() {
      const routeData = this.$router.resolve({
        name: 'Setting Template Delivery Order Detail',
        params: { id: this.item.id },
      })

      window.open(routeData.href, '_blank').focus()
    },
  },
}
</script>